import { useCallback } from 'react'

import { useStatsigClient } from '@statsig/react-bindings'

export enum FeatureGate {
  AIAutomations = 'ai_automations',
  ApplicationAutoCheck = 'application_auto_check',
  EntityVersionMapMode = 'entity_version_map_mode',
  EntityVersionNearbyPropertiesReport = 'entity_version_nearby_properties_report',
  InsightsInspectionsPage = 'insights_inspections_page',
  InsightsCommunityPage = 'insights_community_page',
  // Some sections in the community insights page are restricted to specific orgs or GovWell staff
  InsightsCommunityRestrictedSections = 'insights_community_restricted_sections',
  InspectionCalendarExternalIntegration = 'inspection_calendar_external_integration',
  InspectionsAllowEditingLoggedInspections = 'inspections_allow-editing-logged-inspections',
  NotificationSettingsTab = 'notification_settings_tab',
  RecordFormAutoCheck = 'record_form_auto_check',
  ShowFeeProrateByMonthOption = 'show_fee_prorate_by_month_option',
  ShowAutomaticGenerateToggle = 'show_automatic_generate_toggle',
  ShowAutomaticIssueToggle = 'show_automatic_issue_toggle',
  ShowAutomaticPaymentToggle = 'show_automatic_payment_toggle',
  TimeBasedCitizenInspectionScheduling = 'time-based_citizen_inspection_scheduling',
}

export const useFeatureFlagging = () => {
  const client = useStatsigClient()
  const checkFeatureFlag = useCallback(
    (featureFlag: FeatureGate) => {
      return client.checkGate(featureFlag)
    },
    [client]
  )
  return { checkFeatureFlag }
}

export const useIsInspectionCalendarExternalIntegrationEnabled = (): boolean => {
  const { checkFeatureFlag } = useFeatureFlagging()
  return checkFeatureFlag(FeatureGate.InspectionCalendarExternalIntegration)
}

export const useIsRecordFormAutoCheckEnabled = (): boolean => {
  const { checkFeatureFlag } = useFeatureFlagging()
  return checkFeatureFlag(FeatureGate.RecordFormAutoCheck)
}
